import { useFeature } from 'src/core/common/hooks/useFeature';
import FEATURES from 'src/core/constants/features';

export const useApprovalAccountOwnerRoleEnabled = () => {
  return useFeature(FEATURES.MULTIDIMENSIONAL_APPROVAL_WORKFLOW);
};
